import React, { useEffect, useState } from "react";
import { BreakdownWrapper } from "./styles";
import {
  StyledParagraph,
  StyledTitle,
} from "../CustomAntdComponents/Typography";
import { formatNumberAsCurrency } from "../../utils/helpers";
import { SpaceBetweenAlignContent } from "../CustomAntdComponents/Utitlities";
import { useBookingStore } from "../../store/booking/bookingStore";
import { useRoadSearchStore } from "../../store/roadSearch/roadSearchStore";
import {
  calculateRoadFareBreakdown,
  calculateTotalFare,
  getSelectedSeatsBreakdown,
} from "../AvailableBuses/helper";
import {
  calculateTicketTotal,
  calculateTicketTotalDiscountPrice,
  calculateTicketTotalOldPrice,
  calculateTicketNewTotal,
} from "../AvailableFlights/helper";
import { StrikeThroughAmount } from "../AvailableFlights/styles";
import translations from "../../screens/PassengerDetails/translations";
import { useI18nContext } from "../../utils/I18n";
import { useAuthStore } from "../../store/auth/authStore";
import { CreditAppliedRow } from "../FlightItinerary/styles";

type Props = {
  hideBreakdown: boolean;
  hideCreditAppliedMsg?: boolean;
};
const RoadFareBreakdown = ({ hideBreakdown, hideCreditAppliedMsg }: Props) => {
  const {
    formData: { numberOfAdults },
    selectedBus,
    selectedBusSeat,
  } = useRoadSearchStore();
  const {
    state: { t },
  } = useI18nContext();

  const { bookingPayload, confirmData } = useBookingStore();

  const { totalAmount } = calculateTotalFare(selectedBus, numberOfAdults);
  const paxFares = calculateRoadFareBreakdown(selectedBus);
  const bookingAmount = bookingPayload
    ? calculateTicketTotal(bookingPayload.TicketingDetails)
    : totalAmount;
  const isRoundTripFares = paxFares.length > 1;

  const hasConfirmData = Boolean(confirmData && confirmData.length > 0);
  const confirmOldPrice = hasConfirmData ? calculateTicketTotalOldPrice(confirmData) : 0;
  const confirmNewPrice = hasConfirmData ? calculateTicketNewTotal(confirmData) : 0;

  const discountAmount = confirmData
    ? calculateTicketTotalDiscountPrice(confirmData)
    : 0;

  const { creditApplied, creditAmount } = useAuthStore();
  let displayAmount = bookingAmount;
  let creditDeducted = 0;

  if (hasConfirmData) {
    displayAmount = confirmNewPrice;
    creditDeducted = 0;
  }
  // Business said no discount/credit on road for now
  // else if (creditApplied && creditAmount > 0) {
  //   creditDeducted = Math.min(creditAmount, bookingAmount);
  //   displayAmount = bookingAmount - creditDeducted;
  // }

  const departureSeats = selectedBusSeat && selectedBusSeat.length > 0 ? selectedBusSeat[0] : [];
  const returnSeats = selectedBusSeat && selectedBusSeat.length > 1 ? selectedBusSeat[1] : [];

  const depBreakdown = getSelectedSeatsBreakdown(departureSeats, selectedBus && selectedBus[0] ? selectedBus[0].TotalFare : 0).map(item => ({
    label: `${item.class} (${item.seatNumbers.join(", ")})`,
    price: item.totalPrice
  }));
  const retBreakdown = getSelectedSeatsBreakdown(returnSeats, selectedBus && selectedBus[1] ? selectedBus[1].TotalFare : 0).map(item => ({
    label: `${item.class} (${item.seatNumbers.join(", ")})`,
    price: item.totalPrice
  }));

  const hasSeatsBreakdown = depBreakdown.length > 0 || retBreakdown.length > 0;

  return (
    <div>
      {!hideBreakdown && (
        <BreakdownWrapper>
          {hasSeatsBreakdown ? (
            isRoundTripFares ? (
              <>
                {depBreakdown.length > 0 && (
                  <div style={{ marginBottom: "5px" }}>
                    <StyledParagraph size="small">Departure</StyledParagraph>
                    {depBreakdown.map((item, key) => (
                      <SpaceBetweenAlignContent key={key} style={{ marginBottom: "4px" }}>
                        <StyledParagraph style={{ fontSize: "14px" }}>
                          {item.label}
                        </StyledParagraph>
                        <StyledTitle level={5} style={{ color: "#434455" }}>
                          {formatNumberAsCurrency(item.price || 0, selectedBus[0]?.Currency)}
                        </StyledTitle>
                      </SpaceBetweenAlignContent>
                    ))}
                  </div>
                )}
                {retBreakdown.length > 0 && (
                  <div style={{ marginBottom: "5px" }}>
                    <StyledParagraph size="small">Return</StyledParagraph>
                    {retBreakdown.map((item, key) => (
                      <SpaceBetweenAlignContent key={key} style={{ marginBottom: "4px" }}>
                        <StyledParagraph style={{ fontSize: "14px" }}>
                          {item.label}
                        </StyledParagraph>
                        <StyledTitle level={5} style={{ color: "#434455" }}>
                          {formatNumberAsCurrency(item.price || 0, selectedBus[1]?.Currency || selectedBus[0]?.Currency)}
                        </StyledTitle>
                      </SpaceBetweenAlignContent>
                    ))}
                  </div>
                )}
              </>
            ) : (
              depBreakdown.map((item, key) => (
                <SpaceBetweenAlignContent key={key} style={{ marginBottom: "4px" }}>
                  <StyledParagraph style={{ fontSize: "14px" }}>
                    {item.label}
                  </StyledParagraph>
                  <StyledTitle level={5} style={{ color: "#434455" }}>
                    {formatNumberAsCurrency(item.price || 0, selectedBus[0]?.Currency)}
                  </StyledTitle>
                </SpaceBetweenAlignContent>
              ))
            )
          ) : (
            isRoundTripFares
              ? paxFares.map((f, key) => (
                  <div style={{ marginBottom: "5px" }}>
                    <StyledParagraph size="small">
                      {key === 0 ? "Departure" : "Return"}
                    </StyledParagraph>
                    <SpaceBetweenAlignContent key={key}>
                      <StyledParagraph style={{ fontSize: "14px" }}>
                        Passenger &nbsp;x&nbsp; {numberOfAdults}
                      </StyledParagraph>

                      <StyledTitle level={5} style={{ color: "#434455" }}>
                        {formatNumberAsCurrency(
                          f.TotalFare * numberOfAdults || 0,
                          selectedBus[0]?.Currency
                        )}
                      </StyledTitle>
                    </SpaceBetweenAlignContent>
                  </div>
                ))
              : paxFares.map((f, key) => (
                  <SpaceBetweenAlignContent key={key}>
                    <StyledParagraph style={{ fontSize: "14px" }}>
                      Passenger &nbsp;x&nbsp; {numberOfAdults}
                    </StyledParagraph>

                    <StyledTitle level={5} style={{ color: "#434455" }}>
                      {formatNumberAsCurrency(
                        f.TotalFare * numberOfAdults || 0,
                        selectedBus[0]?.Currency
                      )}
                    </StyledTitle>
                  </SpaceBetweenAlignContent>
                ))
          )}
          {/* Business said no discount/credit on road for now */}
          {/* {!hideCreditAppliedMsg && creditApplied && creditDeducted > 0 && (
            <CreditAppliedRow>
              Credit applied ({formatNumberAsCurrency(creditDeducted, "")} off)
            </CreditAppliedRow>
          )} */}
        </BreakdownWrapper>
      )}

      <SpaceBetweenAlignContent>
        {confirmData?.length && confirmData[0]?.IsDiscounted ? (
          <p className="total-passengers-text">Total for all passengers</p>
        ) : (
          <StyledParagraph size="default">
            Total for all passengers
          </StyledParagraph>
        )}

        <div className="make-payment-amount-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {hasConfirmData ? (
            confirmOldPrice > confirmNewPrice ? (
              <StrikeThroughAmount>
                {formatNumberAsCurrency(confirmOldPrice, selectedBus[0]?.Currency)}
              </StrikeThroughAmount>
            ) : null
          ) : (
            // Business said no discount/credit on road for now
            // creditApplied && creditDeducted > 0 ? (
            //   <StrikeThroughAmount>
            //     {formatNumberAsCurrency(bookingAmount, selectedBus[0]?.Currency)}
            //   </StrikeThroughAmount>
            // ) : null
            null
          )}
          <StyledTitle level={3}>
            {formatNumberAsCurrency(
              displayAmount || 0,
              selectedBus[0]?.Currency
            )}
          </StyledTitle>
        </div>
      </SpaceBetweenAlignContent>
      {confirmData?.length && confirmData[0]?.IsDiscounted ? (
        <div className="discount-container-desktop">
          <span>{t(translations).discountApplied}</span>
          <span className="discount-code-text">
            {confirmData[0]?.PassengerDetails?.PromoCode}
          </span>
          <span className="discount-amount-off-text">
            ({formatNumberAsCurrency(discountAmount, selectedBus[0]?.Currency)}{" "}
            {t(translations).off})
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default RoadFareBreakdown;
